import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var HideSVG = function HideSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,4a9.91,9.91,0,0,1,5.51,1.66L7.66,21.51A10,10,0,0,1,16,6Zm0,20a9.91,9.91,0,0,1-5.51-1.66L24.34,10.49A10,10,0,0,1,16,26Z"
  }));
};
HideSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HideSVG);